export const SET_RELOAD_BROWSER_DIALOG_STATUS =
    'SET_RELOAD_BROWSER_DIALOG_STATUS'

interface IReloadDialogState {
    open: boolean
}

const initialState: IReloadDialogState = {
    open: false,
}

export default function reloadDialogReducer(
    state: IReloadDialogState = initialState,
    { type, payload }: { type: string; payload: any },
) {
    switch (type) {
        case SET_RELOAD_BROWSER_DIALOG_STATUS: {
            return {
                ...state,
                open: payload,
            }
        }
        default:
            return state
    }
}
